<template>
  <div class="card-box resource" v-loading="loading">
    <div class="card-header">最新对接资源</div>
    <div class="card-main">
      <div class="item" v-for="(item, index) in resourceList" :key="index" @click="fileClick(item)">
        <div class="content" v-if="item.demandView">
          <div class="title">{{ item.demandView.content }}</div>
          <div class="info">
            <span class="user">需求人：{{ item.demandView.userName }}</span>
            <span class="time">{{ item.demandView.createdAt }}</span>
          </div>
        </div>
        <div class="content file-data">
          <div class="title">{{ item.name }}</div>
          <div class="info">
            <span class="user">提供人：{{ item.userName }}</span>
            <span class="time">{{ item.createdAt }}</span>
          </div>
        </div>
      </div>
    </div>

    <el-empty description="暂无数据" :image-size="100" v-if="resourceList.length <= 0"></el-empty>

    <el-pagination
      layout="prev, pager, next"
      :total="total"
      :page-size="pageSize"
      :current-page="page"
      class="page-view"
      @current-change="currentChange"
    >
    </el-pagination>
  </div>
</template>

<script>
import { StandardService } from '@/service'

export default {
  data() {
    return {
      page: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      resourceList: [],
    }
  },
  mounted() {
    this.GetDemandResources();
  },
  methods: {
    async GetDemandResources() {
      this.loading = true;
      const res = await StandardService.GetDemandResources(this.page, this.pageSize);
      this.loading = false;
      if (res) {
        this.resourceList = res.list || [];
        this.total = res.total;
      }
    },
    currentChange(page) {
      this.page = page;
      this.GetDemandResources();
    },
    fileClick(value) {
      // const path =  await WinForm.md.saveFileDlg("所有文件(*.*)|*.*", "", data.name2);
			// console.log(`${ApiService.StdApi}/std/${data.filepath}`)
			// WinForm.md.download2(`${ApiService.StdApi}/std/${data.filepath}`, path, '', (key, progress, speed, status, statusDesc, totalSize) => {
			// 	console.log(key, progress, speed, status, statusDesc, totalSize);
			// });
      this.$parent.fileClick(value);
    }
  }
}
</script>

<style lang="less" scoped>
  .card-box {
    background-color: #fff;
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .page-view{
      width: 100%;
      background: #ffffff;
      text-align: right;
    }

    .card-header {
      height: 38px;
      border-bottom: 1px solid rgba(214, 214, 214, 0.5);
      font-size: 16px;
      font-weight: bold;
      color: #2f3848;
      line-height: 38px;
      box-sizing: border-box;
      padding-left: 14px;
      &.border-none {
        border-bottom: none;
      }
    }

    .card-main {
      flex: 1;
      overflow-y: auto;
    }
  }

  .item {
    padding: 12px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid rgba(214, 214, 214, 0.5);
    .content {
      width: 50%;
      padding: 0 14px;
      .title {
        font-size: 14px;
        font-weight: 500;
        color: #2f3748;
      }

      .info {
        margin-top: 7px;
        display: flex;
        font-size: 12px;
        font-weight: 500;
        color: #2f3748;
        .user {
          margin-right: 15px;
        }
        .time {
          font-size: 12px;
          font-weight: 500;
          color: #999999;
        }
      }
    }
    .content:first-child{
      border-right: 1px solid rgba(214, 214, 214, 0.5);;
    }

    .btn {
      width: 86px;
      height: 26px;
      border: 1px solid #0989c5;
      border-radius: 13px;
      font-size: 14px;
      font-weight: bold;
      color: #0989c5;
      box-sizing: border-box;
      line-height: 24px;
      text-align: center;
    }
  }
  .file-data{
    cursor: pointer;
  }
  .file-data:hover{
    *{
      color: #0989c5!important;
    }
  }
</style>
